import { STLExporter } from 'three/examples/jsm/exporters/STLExporter.js';
import { OBJExporter } from 'three/examples/jsm/exporters/OBJExporter.js';

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function exportSTL(group) {
  const exporter = new STLExporter();
  const data = exporter.parse(group, { binary: true });
  downloadBlob(new Blob([data], { type: 'application/octet-stream' }), 'bust_model.stl');
}

export function exportOBJ(group) {
  const exporter = new OBJExporter();
  const data = exporter.parse(group);
  downloadBlob(new Blob([data], { type: 'text/plain' }), 'bust_model.obj');
}
